import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from 'next-themes'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './shared/services/queryClient'
import { SignalRProvider } from './shared/providers/SignalRProvider'
import { FieldErrorProvider } from './shared/contexts/FieldErrorContext'
import { ConfirmProvider } from './shared/contexts/ConfirmContext'
import App from './App'
import './index.css'
import { useAuthStore } from './features/auth/stores/authStore'
import { Toaster } from 'sonner';

useAuthStore.getState().initializeAuth();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <QueryClientProvider client={queryClient}>
        <FieldErrorProvider>
          <ConfirmProvider>
            <SignalRProvider>
              <App />
              <Toaster position="top-center" toastOptions={{ className: "z-[200]" }} />
            </SignalRProvider>
          </ConfirmProvider>
        </FieldErrorProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
)